import useTypedTranslation from '@hooks/useTypedTranslation'

import type { TranslationKey } from '../../../i18n'

type HeadlineProps =
  | { i18nKey: TranslationKey; title?: never }
  | { title: string; i18nKey?: never }

export function Headline({ title, i18nKey }: HeadlineProps) {
  const { t } = useTypedTranslation()

  const caption = title ?? t(i18nKey)

  return (
    <h1 className="text-xl font-medium tracking-tight">
      {caption}
    </h1>
  )
}